import React from "react";

const ErrorPage = () => {
  return (
    <>
    <div className="bg_404">
    <img
            id="bg_404"
            src="404_image.jpeg"
            alt="Prams 404 Background"
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              zIndex: "-10",
              height: "1150px",
              width: "100%",
              // width: "auto",
            }}
          />
    </div>
    </>
  );
};

export default ErrorPage;